import { rgba } from 'polished'
import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  width: 100%;
  padding: 24px;
  background-color: ${({ theme }) => theme.ds.colors.neutral50};

  @media (max-width: 1024px) {
    padding: 16px 8px;
  }
`

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
  max-width: 1072px;
  padding: 40px;
  background-color: ${({ theme }) => theme.ds.colors.white};
  border-radius: ${({ theme }) => theme.ds.typography.border.radius.medium};
  box-shadow: ${({ theme }) => theme.ds.shadows.normal};

  @media (max-width: 1024px) {
    padding: 32px 16px;
  }
`

export const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`

export const Illustration = styled.span`
  margin-top: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  @media (max-width: 1024px) {
    margin-top: 24px;
    svg {
      max-height: 70px;
    }
  }
`

export const ForecastWrapper = styled.div`
  margin: 24px 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 1024px) {
    margin: 16px 0;
  }
`

export const InfoCard = styled.div`
  width: 100%;
  padding: 12px;
  background-color: ${({ theme }) => theme.ds.colors.success50};
  border: 1px solid ${({ theme }) => rgba(theme.ds.colors.success500, 0.3)};
  border-radius: ${({ theme }) => theme.ds.typography.border.radius.small};
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const InfoCardTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  svg {
    flex-shrink: 0;
  }
`
